
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom'; //eslint-disable-line
import { Provider } from 'react-redux';
import App from './app.jsx';
import { Bridge } from '@nackle/bridge';
import umbrella from '@nackle/umbrella';
const { loadModule } = umbrella;

import { doorUrl, alloyUrl } from 'endpoints';
import { initializeFaro, getWebInstrumentations, SessionInstrumentation, FetchTransport, ConsoleTransport } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { PerformanceTimelineInstrumentation } from '@grafana/faro-instrumentation-performance-timeline';


( async () => {


    let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
        return [ 'localhost', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );

    let isLocalhost = false;

    if ( env === 'localhost' ) {
        env = 'qa';
        isLocalhost = true;

    }
    if ( !isLocalhost ) {
        try {
            initializeFaro( {
                app: {
                    name: 'elevate-ui',
                    version: '1.0.0',
                },
                instrumentations: [ ...getWebInstrumentations( { captureConsole: true, captureConsoleDisabledLevels: [ 'debug', 'trace' ] } ), new TracingInstrumentation(), new PerformanceTimelineInstrumentation(), new SessionInstrumentation() ],
                sessionTracking: {
                    session: {
                        attributes: {
                            'url': window.location.href,
                        },
                    },
                },
                trackWebVitalsAttribution: true,
                transports: [
                    new FetchTransport( {
                        url: alloyUrl
                    } ),
                    new ConsoleTransport(),
                ],

            } );
        } catch ( error ) {
            console.log( 'error initializing Faro', error );
        }
    }
    if ( window.location.pathname.startsWith( '/door' ) ) {
        const KadhavuApp = await ( loadModule( doorUrl, 'door', './kadhavu-app', 'door' ) );
        const KadhavuAppStore = await ( loadModule( doorUrl, 'door', './kadhavu-app-store', 'door' ) );
        // the webapp likely redirected from the else so this stops it from trying to load everything in
        unmountComponentAtNode( document.getElementById( 'app-root' ) );

        return (
            render(
                <Provider store={ KadhavuAppStore.default() }>
                    <KadhavuApp.default isUmbrella={ true } />
                </Provider>,
                document.getElementById( 'app-root' )
            ) );
    } else  {
        const hostname = window.location.hostname;
        let auth;
        if ( hostname === 'localhost' ) {
            auth = umbrella.getAuth( true, 20, 19, {
                authority: 'https://qa.recognition-now.io/api/v1/id',
                extraQueryParams: { source: window.location.href },
            } );
        } else {
            const domainParts = hostname.split( '.' );
            domainParts.shift();
            const domain = domainParts.join( '.' );
            // auth
            auth = umbrella.getAuth( true, 20, 19, { authority: `https://${ domain }/api/v1/id`, extraQueryParams: { source: window.location.href } } );
        }


        const registerServiceWorker = async () => {
            if ( 'serviceWorker' in navigator ) {
                try {
                    if ( window.location && window.location.hostname === 'localhost' ) {
                        await navigator.serviceWorker.register( new URL( '../sw.js', import.meta.url ), { scope: '../' } );
                    } else if ( window.location && window.location.pathname !== '/oidc_renew' ) {
                        await navigator.serviceWorker.register( new URL( '../sw.js', import.meta.url ), { scope: '/' } );
                    }
                    window.addEventListener( 'offline', handleConnectivityStatusChange );
                    window.addEventListener( 'online', handleConnectivityStatusChange );

                } catch ( error ) {
                    console.error( `Registration failed with ${ error }` );
                }
            }
        };
        if ( window.location && window.location.pathname !== '/oidc_renew' ) {
            registerServiceWorker();
        }

        const handleConnectivityStatusChange = ( event ) => {
            const onlineStatus = navigator.onLine ? true : false;
            //if not online, reload the page to trigger a navigation to display offline fallback from service worker
            if ( !onlineStatus ) {
                window.location.assign( window.location.href );
            //if online and previously was offline, reload the page to redisplay umbrella and stop displaying the fallback
            } else if ( onlineStatus && ( onlineStatus !== navigator.onLine ) ) {
                window.location.reload();
            }
        };
        render(
            <Bridge
                auth={ auth }
                requiresAuth={ true }
            >
                <App
                    auth={ auth }
                />
            </Bridge>,
            document.getElementById( 'app-root' )
        );
    }
} )();